import { useCallback, useEffect, useState } from 'react';
import { adminApi } from '../services/api';
import { annoncerErreur, annoncerSucces, confirmer } from '../etats';

/* Comptes de l'organisation (administration), fusionnés au tableau des
   participants. Deux dirigeants, dont un principal, ont accès à tout ; les
   membres forment l'équipe à qui l'on attribue des modules. */
export function useComptesOrganisation(projetId, actif, apresChangement) {
  const [comptes, setComptes] = useState([]);
  const [enCours, setEnCours] = useState(null);

  const charger = useCallback(async () => {
    if (!actif) return;
    try {
      const r = await adminApi.getComptesOrganisation(projetId);
      setComptes(r.comptes || []);
    } catch (e) {
      setComptes([]);
    }
  }, [projetId, actif]);

  useEffect(() => { charger(); }, [charger]);

  const agir = async (c, question, appel, succes) => {
    if (!await confirmer(question)) return;
    setEnCours(c.id);
    try {
      const r = await appel();
      setComptes(r.comptes || []);
      annoncerSucces(succes);
      if (apresChangement) apresChangement();
    } catch (e) {
      annoncerErreur(e.message || 'L’opération n’a pas abouti.');
    } finally {
      setEnCours(null);
    }
  };

  const changer = (c, role) => agir(c,
    role === 'DIRIGEANT'
      ? `Passer ${c.nom} en dirigeant ? Il aura accès à tout l’espace et à tous les modules${c.participant ? ', et quittera l’équipe des membres' : ''}.`
      : c.role === 'MEMBRE'
        ? `Ajouter ${c.nom} à l’équipe des membres ?`
        : `Passer ${c.nom} en membre ? Il rejoindra l’équipe des membres et n’aura plus accès à la facturation, aux rapports, aux échanges ni aux documents.`,
    () => adminApi.setRoleCompte(projetId, c.id, role),
    role === 'DIRIGEANT' ? `${c.nom} est désormais dirigeant.` : `${c.nom} fait partie de l’équipe des membres.`);

  const designerPrincipal = (c) => agir(c, `Désigner ${c.nom} comme dirigeant principal ?`,
    () => adminApi.setPrincipalCompte(projetId, c.id), `${c.nom} est le dirigeant principal.`);

  const retirer = (c) => agir(c,
    `Supprimer ${c.nom} de l’organisation ? Son compte sera fermé ; ses réponses passées restent.`,
    () => adminApi.retirerCompte(projetId, c.id), `${c.nom} a été retiré de l’organisation.`);

  return { comptes, changer, designerPrincipal, retirer, enCours };
}

/* Les boutons de rôle d'un compte. */
export function ChangerRole({ compte, gestion }) {
  if (!compte) return null;
  const { changer, designerPrincipal, enCours } = gestion;
  const occupe = enCours === compte.id;
  const dirigeant = compte.role === 'DIRIGEANT' && !compte.participant;
  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {dirigeant && !compte.principal && compte.actif && (
        <button type="button" disabled={occupe} onClick={() => designerPrincipal(compte)} className="act act-sm act-contour">
          Désigner principal
        </button>
      )}
      {dirigeant && (
        <button type="button" disabled={occupe} onClick={() => changer(compte, 'MEMBRE')} className="act act-sm act-contour">
          Passer membre
        </button>
      )}
      {!dirigeant && (
        <button type="button" disabled={occupe} onClick={() => changer(compte, 'DIRIGEANT')} className="act act-sm act-contour">
          Passer dirigeant
        </button>
      )}
      {compte.role === 'MEMBRE' && !compte.participant && compte.actif && (
        <button type="button" disabled={occupe} onClick={() => changer(compte, 'MEMBRE')} className="act act-sm act-contour">
          Ajouter à l’équipe
        </button>
      )}
    </div>
  );
}
